import { UseQueryResult } from "react-query";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { RemoteApiError } from "../useRemote/types";

export type FleetBlockedUsersResponse = {
  blockedAt: string;
  blockedBy: string;
  id: number;
  reason: string | null;
  tenantId: number;
  userId: string;
  vehicleInventoryId: number;
};

/**
 * Fetches blocked user IDs for a vehicle (GET /fleet/vehicles/:vehicleId/blocked-users).
 * Only runs when vehicleId is set.
 */
export function useRemoteFetchFleetBlockedUsers(
  vehicleId: number | null
): UseQueryResult<FleetBlockedUsersResponse[], RemoteApiError> {
  const result = useRemoteQuery<FleetBlockedUsersResponse[], RemoteApiError>({
    queryKey: ["fleet", "vehicles", vehicleId, "blocked-users"],
    url: `/fleet/vehicles/${vehicleId}/blocked-users`,
    enabled: vehicleId != null
  });

  return { ...result, data: result.data } as UseQueryResult<
    FleetBlockedUsersResponse[],
    RemoteApiError
  >;
}
